export const getLiveChatScriptUrl = (appId: string): string =>
  `https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/${appId}`
